module.exports = __webpack_public_path__ + "c6b05a2328d60bc6a669bcbded4e8566.MP3";